module.exports = __webpack_public_path__ + "5d665528ef12074560d2beaba4a1a126.png";